(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-detail"] && !Shopify.designMode) return;
  try {
    /*
    Editorial accent: highlight the closing word of each article H2 in the
    peach accent colour. Runs once, leaves headings untouched if they
    already contain an accent (e.g. authored manually in the rich text).
  */
  (function () {
    function accentHeadings() {
      var headings = document.querySelectorAll('.article-detail__content h2');

      Array.prototype.forEach.call(headings, function (heading) {
        if (heading.querySelector('.article-detail__accent')) return;

        var walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
        var textNode = null;

        while (walker.nextNode()) {
          if (walker.currentNode.textContent.trim() !== '') {
            textNode = walker.currentNode;
          }
        }

        if (!textNode) return;

        var text = textNode.textContent;
        var match = text.match(/(\S+)(\s*)$/);
        if (!match) return;

        var accent = document.createElement('span');
        accent.className = 'article-detail__accent';
        accent.textContent = match[1];

        textNode.textContent = text.slice(0, match.index);

        var parent = textNode.parentNode;
        parent.insertBefore(accent, textNode.nextSibling);
        parent.insertBefore(document.createTextNode(match[2]), accent.nextSibling);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', accentHeadings);
    } else {
      accentHeadings();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
